"use strict";

/*
 *  FRONT: Order Form: Full-fill company detail in form by Company Reg. No.
 */

window.KMBillingAddressFormContainerInit = () => {
  initOrganisationBillingAddressFormContainer();

  // Order form fields
  const regNumberInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingCompanyIdentification-companyRegNumber,' +
  // admin order detail
  '#frm-billingCompanyIdentification-companyRegNumber,' +
  // front shopping cart
  '#km-billingAddressFormContainer-companyIdentification-companyRegNumber,' +
  // front registration, front edit account, admin customer detail
  '#frm-companyIdentification-companyRegNumber').first(); // claim form

  if (regNumberInput.data('billing-form-initialized')) {
    return;
  }
  regNumberInput.data('billing-form-initialized', true);
  const vatNumInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingCompanyIdentification-vatIdNumber,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-vatIdNumber, ' +
  // front shopping cart
  '#km-billingAddressFormContainer-companyIdentification-vatIdNumber,' +
  // front registration, front edit account, admin customer detail
  '#frm-claimForm-claimForm-companyIdentification-vatIdNumber').first(); // claim form

  const taxNumInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingCompanyIdentification-taxIdNumber,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-taxIdNumber, ' +
  // front shopping cart
  '#km-billingAddressFormContainer-companyIdentification-taxIdNumber, ' +
  // front registration, front edit account, admin customer detail
  '#frm-claimForm-claimForm-companyIdentification-taxIdNumber').first(); // claim form

  const customerInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingCompanyIdentification-companyName,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-companyName,' +
  // front shopping cart
  '#km-billingAddressFormContainer-companyIdentification-companyName').first(); // front registration, front edit account, admin customer detail

  const countryCodeInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingPostalAddress-country,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-country,' +
  // front shopping cart
  '#km-billingAddressFormContainer-postalAddress-country,' +
  // front registration, front edit account, admin customer detail
  '#frm-claimForm-claimForm-country').first(); // claim form

  const streetInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingPostalAddress-streetAndHouseNumber,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-streetAndHouseNumber, ' +
  // front shopping cart
  '#km-billingAddressFormContainer-postalAddress-streetAndHouseNumber').first(); // front registration, front edit account, admin customer detail

  const cityInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingPostalAddress-city,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-city, ' +
  // front shopping cart
  '#km-billingAddressFormContainer-postalAddress-city').first(); // front registration, front edit account, admin customer detail

  const postalCodeInput = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingPostalAddress-postalCode,' +
  // admin order detail
  '#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-postalCode,' +
  // front shopping cart
  '#km-billingAddressFormContainer-postalAddress-postalCode').first(); // front registration, front edit account, admin customer detail

  const inputs = [customerInput, vatNumInput, streetInput, cityInput, postalCodeInput, taxNumInput];
  const submitButton = $('#frm-orderDetailTop-contactBillingDeliveryDetails-form-billingCompanyIdentification-companyRegNumber-autofillLink,' +
  // admin order detail
  '#frm-billingCompanyIdentification-companyRegNumber-autofillLink,' +
  // front shopping cart
  '#km-billingAddressFormContainer-companyIdentification-autofill > a').first(); // front registration, front edit account, admin customer detail

  const loadingPhrase = regNumberInput.data('autofill-loading-phrase');
  const regNumberNotFoundPhrase = regNumberInput.data('autofill-reg-number-not-found-phrase');
  const countryNotSupportedPhrase = regNumberInput.data('autofill-country-not-supported-phrase');
  const requiredPhrase = regNumberInput.data('autofill-required-phrase');
  const endpoint = regNumberInput.data('autofill-endpoint');
  const autofillSupportedCountryCodes = ['CZ', 'SK', 'GB', 'FI', 'NO', 'SE'];
  let isLoading = false;
  if (!window.KM) {
    window.Nette.addError = function (elem, message) {
      alert(message);
    };
  }
  const companyInfoCheckboxes = $('#frm-deliveryPaymentAddress-addressForm-billingDetailsFilledIn,' + '#km-userAddressesFormContainer-billingAddressCheckbox,' + '#frm-claimForm-claimForm-isCompany').first();
  const companyInfoCheckbox = companyInfoCheckboxes[0];
  const vatNumInputToggle = () => {
    let isChecked = companyInfoCheckbox ? companyInfoCheckbox.checked : false;
    if (!(countryCodeInput.data('vat-id-country-codes') ?? []).includes(countryCodeInput.val())) {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        vatNumInput.parent().closest('tr').hide();
        vatNumInput.prop('disabled', true);
        vatNumInput.val('');
      }
    } else {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        vatNumInput.parent().closest('tr').show();
        if (!vatNumInput.data('permission-disabled')) {
          vatNumInput.prop('disabled', false);
        }
      }
    }
  };
  const taxIdInputToggle = () => {
    let isChecked = companyInfoCheckbox ? companyInfoCheckbox.checked : false;
    if (!(countryCodeInput.data('tax-id-country-codes') ?? []).includes(countryCodeInput.val())) {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        taxNumInput.parent().closest('tr').hide();
        taxNumInput.prop('disabled', true);
        taxNumInput.val('');
      }
    } else {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        taxNumInput.parent().closest('tr').show();
        if (!taxNumInput.data('permission-disabled')) {
          taxNumInput.prop('disabled', false);
        }
      }
    }
  };
  const autofillLinkToggle = () => {
    const $row = submitButton.parent().closest('tr');
    let isChecked = companyInfoCheckbox ? companyInfoCheckbox.checked : false;
    if (autofillSupportedCountryCodes.includes(countryCodeInput.val())) {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        $row.show();
      }
    } else {
      if (companyInfoCheckbox && isChecked || !companyInfoCheckbox) {
        $row.hide();
      }
    }
  };
  const isReverseChargeAppliedCheckbox = document.getElementById('frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-isReverseChargeApplied');
  const $reverseChargeAppliedCheckbox = $(isReverseChargeAppliedCheckbox);
  const $reverseChargeValidationMessage = $('#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-reverseChargeValidationMessage');
  const $reverseChargeValidationMessageRow = $reverseChargeValidationMessage.closest('tr');
  const clearReverseChargeApplied = () => {
    if (!isReverseChargeAppliedCheckbox) {
      return;
    }
    $reverseChargeValidationMessage.html('<div class="kvikymart-scdpa-ajax-loader"></div>').attr('hidden', 'hidden');
    $reverseChargeValidationMessageRow.hide();
    $reverseChargeAppliedCheckbox.prop('checked', false).trigger('change');
  };
  const isReverseChargeAppliedToggle = () => {
    const isChecked = companyInfoCheckbox ? companyInfoCheckbox.checked : false;
    if (!isReverseChargeAppliedCheckbox) {
      return;
    }
    const reverseChargeCountryCodes = $reverseChargeAppliedCheckbox.data('reverse-charge-country-codes') ?? [];
    const isReverseChargeCountry = reverseChargeCountryCodes.includes(countryCodeInput.val());
    const $row = $reverseChargeAppliedCheckbox.closest('tr');
    if (companyInfoCheckbox && !isChecked) {
      $row.hide();
      $reverseChargeValidationMessageRow.hide();
      return;
    }
    if (isReverseChargeCountry) {
      $row.show();
      return;
    }
    $row.hide();
    $reverseChargeValidationMessageRow.hide();
  };
  const countryInputChange = () => {
    initCountryDependentCompanyIdentificationInputs(regNumberInput, taxNumInput, vatNumInput, countryCodeInput, () => {
      if (!window.smartform) {
        return;
      }
      const selectedCountry = countryCodeInput.val();
      // noinspection OverlyComplexBooleanExpressionJS
      if ((selectedCountry === 'CZ' || selectedCountry === 'SK') && window.smartform && window.smartform.hasOwnProperty('getInstance') && window.smartform.getInstance instanceof Function) {
        const billingInstance = window.smartform.getInstance('smartform-instance-billingPostalAddress');
        if (billingInstance?.addressControl) {
          billingInstance.addressControl.setCountry(selectedCountry);
        }
      }
    });
  };
  if (companyInfoCheckbox) {
    companyInfoCheckbox.onchange = () => {
      setTimeout(function () {
        if (!companyInfoCheckbox.checked) {
          clearReverseChargeApplied();
        }
        vatNumInputToggle();
        taxIdInputToggle();
        autofillLinkToggle();
        isReverseChargeAppliedToggle();
      }, 20);
    };
  }
  countryCodeInput.change(autofillLinkToggle);
  countryCodeInput.change(vatNumInputToggle);
  countryCodeInput.change(taxIdInputToggle);
  countryCodeInput.change(() => {
    clearReverseChargeApplied();
    isReverseChargeAppliedToggle();
  });
  autofillLinkToggle();
  vatNumInputToggle();
  taxIdInputToggle();
  isReverseChargeAppliedToggle();
  countryInputChange();
  submitButton.on('click', function (e) {
    e.preventDefault();
    if (!regNumberInput[0] || !window.Nette.validateControl(regNumberInput[0])) {
      return;
    }
    const regNumValue = regNumberInput.val();
    const countryCodeValue = countryCodeInput.val();
    if (!regNumValue) {
      window.Nette.addError(regNumberInput, requiredPhrase);
      return;
    }
    $.ajax({
      url: endpoint + `?countryCode=${countryCodeValue}&companyRegistrationNumber=${regNumValue}`,
      beforeSend: function () {
        if (isLoading) {
          return false;
        }
        stateLoading();
      },
      error: function (xhr) {
        stateFinishedLoading();
        window.Nette.addError(regNumberInput, regNumberNotFoundPhrase);
      },
      success: function (data) {
        // success: function(data, textStatus, xhr){
        stateFinishedLoading();
        writeDataToInputs(data);
      }
    });
  });
  function stateLoading() {
    isLoading = true;
    appendLoadingIndicator();
    inputs.forEach(field => {
      if (field.val() === '') {
        field.attr('placeholder', loadingPhrase);
      }
    });
  }
  function appendLoadingIndicator() {
    let spinner;
    if (window.km_spinner) {
      spinner = $(window.km_spinner.html);
    } else {
      spinner = $(window.KMA.LoadingPane.getSpinnerHtml());
    }
    spinner.css({
      margin: 0
    });
    const spinnerWrapper = $('<div class="ajax-loader ajaxLoader billingAddressFormContainerLoadingSpinner"></div>');
    spinnerWrapper.append(spinner);
    submitButton.after(spinnerWrapper);
    const scale = submitButton.outerHeight() / spinner.outerHeight();
    // console.log(submitButton.outerHeight());
    // console.log(spinner.outerHeight());
    // console.log(scale);

    spinnerWrapper.css({
      display: 'inline-block',
      height: submitButton.outerHeight() + 'px',
      verticalAlign: 'top',
      transform: 'scale(' + scale + ')',
      transformOrigin: '0 0'
    });
  }
  function removeLoadingIndicator() {
    $('.billingAddressFormContainerLoadingSpinner').remove();
  }
  function stateFinishedLoading() {
    isLoading = false;
    removeLoadingIndicator();
    inputs.forEach(field => {
      field.attr('placeholder', '');
    });
  }
  function writeDataToInputs(data) {
    if (data.companyName) {
      customerInput.val(data.companyName);
    }
    if (data.taxIdNumber) {
      taxNumInput.val(data.taxIdNumber);
    }
    if (data.vatIdNumber) {
      vatNumInput.val(data.vatIdNumber);
    }
    if (data.streetAndHouseNumber) {
      streetInput.val(data.streetAndHouseNumber);
    }
    if (data.city) {
      cityInput.val(data.city);
    }
    if (data.postalCode) {
      postalCodeInput.val(data.postalCode);
    }
  }
};
function initOrganisationBillingAddressFormContainer() {
  const prefix = '#km-organisationBillingAddressFormContainer-';
  const regNumberInput = $(prefix + 'companyIdentification-companyRegNumber');
  if (!regNumberInput.length || regNumberInput.data('billing-form-initialized')) {
    return;
  }
  regNumberInput.data('billing-form-initialized', true);
  initCountryDependentCompanyIdentificationInputs(regNumberInput, $(prefix + 'companyIdentification-taxIdNumber'), $(prefix + 'companyIdentification-vatIdNumber'), $(prefix + 'postalAddress-country'));
}
function initCountryDependentCompanyIdentificationInputs(regNumberInput, taxNumInput, vatNumInput, countryCodeInput) {
  let beforeUpdate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : () => {};
  const updateInputs = () => {
    const selectedCountry = countryCodeInput.val();
    beforeUpdate();
    [{
      dataKey: 'company-reg-no-data-per-country',
      input: regNumberInput
    }, {
      dataKey: 'tax-id-data-per-country',
      input: taxNumInput
    }, {
      dataKey: 'vat-id-data-per-country',
      input: vatNumInput
    }].forEach(_ref => {
      let {
        dataKey,
        input
      } = _ref;
      const data = countryCodeInput.data(dataKey);
      if (!input.length || !data?.[selectedCountry]) {
        return;
      }
      const {
        label,
        placeholder
      } = data[selectedCountry];
      if (placeholder !== '') {
        input.attr('placeholder', placeholder);
      }
      if (label !== '') {
        $('label[for="' + input.attr('id') + '"]').text(label);
      }
    });
  };
  countryCodeInput.change(updateInputs);
  updateInputs();
}
jQuery(document).ready(() => {
  window.KMBillingAddressFormContainerInit();
});
document.addEventListener('KMDeliveryPaymentAddressControl.addressFormLoaded', () => {
  window.KMBillingAddressFormContainerInit();
});